module.exports = __webpack_public_path__ + "static/media/arrow-left.23d8784b.svg";